const mediaItems = [
  {
    title: '《暗夜追凶》终极预告',
    type: '电影预告',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20scene%20with%20dark%20moody%20atmosphere%2C%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%2C%20dramatic%20film%20noir%20lighting%2C%20suspenseful%20tone&width=640&height=360&seq=media-01-night-chase&orientation=landscape',
  },
  {
    title: '《星河帝国》幕后花絮',
    type: '幕后特辑',
    duration: '05:18',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20scene%20with%20warm%20golden%20nebula%2C%20cosmic%20atmosphere%2C%20abstract%20digital%20art%2C%20elegant%20dark%20background%20with%20stars&width=640&height=360&seq=media-02-scifi&orientation=landscape',
  },
  {
    title: '《长安十二时辰》经典片段',
    type: '精彩剪辑',
    duration: '03:42',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20atmosphere%20with%20warm%20lantern%20light%2C%20traditional%20architecture%20silhouette%2C%20golden%20and%20amber%20tones%2C%20elegant%20cinematic%20composition&width=640&height=360&seq=media-03-ancient&orientation=landscape',
  },
  {
    title: '《深海迷踪》导演访谈',
    type: '独家专访',
    duration: '08:10',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20atmosphere%20with%20dark%20blue%20and%20teal%20tones%2C%20soft%20light%20rays%20piercing%20water%2C%20abstract%20underwater%20textures%2C%20cinematic%20mood&width=640&height=360&seq=media-04-deep-sea&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
            精彩视频
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            预告片与精彩花絮
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            抢先观看最新影视预告与幕后精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-300/20 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      parent.classList.add('bg-background-200');
                      parent.classList.add('flex');
                      parent.classList.add('items-center');
                      parent.classList.add('justify-center');
                    }
                  }}
                />
                <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-background-950 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-200">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}